module.exports = __webpack_public_path__ + "static/media/zara.15205a82.png";